import { InjectionToken } from '@angular/core';

export interface Environment {
  production: boolean;
  apiUrl: string;
  appName: string;
  version: string;
}

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');
